(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('#shopify-section-header');
      this.navigation = this.header.querySelector('.header-section-inner__bottom');
      this.searchBoxes = this.header.querySelectorAll('.search-inner input');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('.site-search__wrapper');
      this.countdownEls = this.querySelectorAll('[data-countdown-timer]');
      if (this.countdownEls.length > 0) {
        this.initCountdowns();
      }

      window.addEventListener('scroll', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
      this.searchBoxes.forEach( searchBox => {
        searchBox.addEventListener('focus', this.toggleSearch);
      })
      this.setHeaderHeight();
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--upper-header-height', `${this.header.offsetHeight - this.navigation.offsetHeight - 1}px`);
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    toggleSearch() {
      document.body.classList.toggle('search-open'); 
    }

    initCountdowns() {
      this.countdownEls.forEach((el) => {
        this.initSingleCountdown(el);
      });
    }

    initSingleCountdown(el) {
      const rawDate = el.dataset.endDate; // YYYY-MM-DD
      let rawTime = el.dataset.endTime || '23:59'; // fallback if empty

      if (!rawTime || !/^\d{2}:\d{2}$/.test(rawTime)) {
        rawTime = '23:59'; // fallback if invalid
      }

      const targetDate = `${rawDate} ${rawTime}:59`; // ensure seconds

      const useClapper = el.dataset.clapper === 'true';

      const updateCountdown = () => {
        const endTime = new Date(targetDate).getTime();
        const now = new Date().getTime();
        const diff = endTime - now;

        if (diff <= 0) {
          el.textContent = 'Offer has ended';
          clearInterval(timerId);
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / 1000 / 60) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        if (useClapper) {
          el.innerHTML = `
            <span class="timer-unit">
              <span class="timer-number">${days}</span><span class="timer-label">d</span>
            </span>
            <span class="timer-unit">
              <span class="timer-number">${hours}</span><span class="timer-label">h</span>
            </span>
            <span class="timer-unit">
              <span class="timer-number">${minutes}</span><span class="timer-label">m</span>
            </span>
            <span class="timer-unit">
              <span class="timer-number">${seconds}</span><span class="timer-label">s</span>
            </span>
          `;
        } else {
          el.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        }
      };

      updateCountdown(); // initial run
      const timerId = setInterval(updateCountdown, 1000); // update every second
    }

  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
